/**
 * Logout page
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionActions } from '@store/actions';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-logout',
  template: '',
})
export class LogoutComponent implements OnInit {
  public constructor(
    private sessionActions: SessionActions,
    private router: Router,
  ) {}

  /**
   * This methods is called when we log out from XPRT portal
   */
  public ngOnInit(): void {
    this.sessionActions.logoutUser();
    this.router.navigate(['login']);
  }
}
